export const MESSAGES = {
  RECONCILE_SUCCESS: "Participant successfully mapped to booking",
  RECONCILE_FAILURE: "Failed to map participant to booking",
  EXPORT_FAILURE: "Failed to export participants. Please try again.",
  INVALID_DATA: "invalid data: ",
  FETCH_SESSION_DETAILS_ERROR_WHEN:
    "fetching sessionDetails in SessionParticipantsPage",
  FETCH_LISTING_DETAILS_ERROR_WHEN: "calling fetchListingDetails",
  FETCH_PARTICIPANTS_ERROR_WHEN: "calling fetchParticipants",
  EXPORT_PARTICIPANTS_ERROR_WHEN: "exporting session participants",
  SEARCH_BOOKED_ERROR_WHEN: "searching booked customers in ReconciliationModal",
  CONFIRM_MAP_ERROR_WHEN: "confirming mapping in ReconciliationModal",
  PAGE_OCCURRENCE: "SessionParticipantsPage",
  HOOK_OCCURRENCE: "useSessionParticipants hook",
  RECONCILIATION_MODAL_OCCURRENCE: "ReconciliationModal",
  FETCH_MEETING_DETAILS_ERROR_WHEN: "calling fetchMeetingDetails",
  EXPORT_ATTENDANCE_ERROR_WHEN: "exporting meeting attendance",
  MEETING_DETAILS_HOOK_OCCURRENCE:
    "src/ui/pages/ZoomAttendance/ZoomAttendanceOfListing/hooks/useListingMeetingDetails.js",
};
